import React from "react";
import Navbar from "../components/Navbar";

const UserD = () => {
  return (
    <>
      <Navbar></Navbar>
      <h1 className="flex justify-center font-semibold">
        Dashboard is in developement currently. Come back later...
      </h1>
      <h3 className="flex justify-center font-semibold">Happy Saving</h3>
    </>
  );
};

export default UserD;
